import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useDebounce } from './useDebounce';
import { normalizeError } from '@/lib/error-types';

interface SearchResult {
  id: string;
  user_id: string;
  first_name: string;
  last_name: string;
  username: string;
  avatar_url: string | null;
  rank_score: number;
}

export const useUserSearch = (searchQuery: string) => {
  const debouncedQuery = useDebounce(searchQuery, 300);

  const { data: users = [], isLoading } = useQuery({
    queryKey: ['user-search', debouncedQuery],
    queryFn: async () => {
      if (!debouncedQuery.trim()) {
        return [];
      }

      const { data, error } = await supabase.rpc('search_profiles', {
        search_query: debouncedQuery,
        limit_count: 10
      });

      if (error) throw normalizeError(error);
      return (data || []) as SearchResult[];
    },
    enabled: !!debouncedQuery.trim(),
    staleTime: 30000, // Cache results for 30 seconds
  });

  return { users, isLoading };
};
